module.exports = __webpack_public_path__ + "static/media/vissel.78266c96.svg";